export default __webpack_public_path__ + "static/floor-plan-PH4AR-a49095c7a1c5f7656b855fcf667cd763.pdf";